import { render, staticRenderFns } from "./HealthInfo.vue?vue&type=template&id=4db92446&scoped=true&"
import script from "./HealthInfo.vue?vue&type=script&lang=js&"
export * from "./HealthInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db92446",
  null
  
)

export default component.exports